export const pages = {
    patientChart: 'Patient Chart',
    careNotes: 'Orpyx Care Notes'
}